import { useEffect } from "react";
import { useFormikContext } from "formik";
import { SimpleClusterForm } from "@/types";
import { SavedSshKeysDeploySection } from "./components/SavedSshKeysDeploySection";

const ConfigureEnvironmentAndSSHKeys: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<SimpleClusterForm>();

  // No image picker: every VM deploys the general-purpose image.
  useEffect(() => {
    if (values.vmImageType !== "general") {
      setFieldValue("vmImageType", "general");
    }
  }, [values.vmImageType, setFieldValue]);

  useEffect(() => {
    if (values.sshType !== "manual") {
      setFieldValue("sshType", "manual");
    }
  }, [setFieldValue, values.sshType]);

  return (
    <div className="flex flex-1 flex-col gap-4 max-lg:w-full">
      <SavedSshKeysDeploySection />
    </div>
  );
};

export default ConfigureEnvironmentAndSSHKeys;
